var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-style-control"},_vm._l((_vm.options),function(option){return _c('a',{key:option.type,class:{active: option.type === _vm.value},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('input', option.type)}}},[_c('svg-icon',{attrs:{"name":option.icon}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }